import { imageModel } from "./defaults";

export const grokImagine2 = imageModel("grok-imagine-2", "Grok Imagine 2.0", {
  text: "xai/grok-imagine-image-2.0",
});
